import React from "react";
import { Waves2 } from "../assets/";
import { MainHero } from "../components";
import "../components/animations/index.css";
// import TypeIt from "typeit-react";

const Main = () => {
  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative flex-col z-8">
      <div className="absolute -z-10 py-[100px] left-[-200px] animate-slide-in-left md:left-[-50px]">
        <Waves2 />
      </div>
      <div className="w-screen h-auto py-[100px]">
        <MainHero />
      </div>

      <div className="flex justify-center items-center w-full bg-[#49A6AB] text-white text-[25px]  py-[50px] md:text-[30px] lg:text-[50px]">
        {/*<TypeIt
          getBeforeInit={(instance) => {
            instance
              .type("Two problems, no solution")
              .pause(750)
              .move(-9, { delay: 100 })
              .delete(2)
              .pause(300)
              .type('<strong style="font-weight: 900;">one</strong>')
              .move(null, { to: "END" })
              .type(" !");
            // Remember to return it!
            return instance;
          }}
        />*/}
      </div>

      <div className="flex justify-center w-full bg-white">
        <div className="flex gap-10 justify-around flex-col items-stretch w-full bg-white py-[50px] px-[30px] md:flex-row md:max-w-[1500px]">
          <div />
        </div>
        {/*<WhoAreWe /> */}
      </div>

        <div
            className="flex justify-center items-center w-full bg-RougePastel text-white text-[20px]  py-[50px] md:text-[25px] md:py-[90x] lg:text-[40px] text-center
      " id="main_video_div"
        >
            <div
                className="md:flex-row md:max-w-[1500px]
        px-[90px] 
        "
            >
                What if a system could serve as both a heating system and a water purifier at the same time ?
            </div>
            <iframe
                className="main_video"
                id="main_video"
                title="Ionis-Paris: Clean Heat : a bio-based heating and water depolluting system (2023) - Project Promotion [English]"
                width="560" height="315" src="https://video.igem.org/videos/embed/851480d0-d4dd-4afe-9b1e-49693ea5dd05"
                frameBorder="0" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>
        </div>
    </div>
  );
};
// TODO: Ajouter un disclaimer ! Pour safari

export default Main;
